import http from "@/http";
// 注册
export const registered = data => {
  return http({
    url: "/user/registered",
    method: "post",
    data
  });
};

// 登陆
export const login = data => {
  return http({
    url: "/user/login",
    method: "post",
    data
  });
};

// 退出登录
export const loginOut = params => {
  return http({
    url: "/v1/user/loginOut",
    method: "post",
    params
  });
};
//用户信息
export const getUserInfo = params => {
  return http({
    url: "/v1/self",
    method: "get",
    params
  });
};
//权限菜单
export const getPermission = params => {
  return http({
    url: "/v1/menu",
    method: "get",
    params
  });
};
